import { requestBuilder } from '../../../http/RequestBuilder';
import { type AllAccountsWithBeneficiariesDetails } from '../../types/Beneficiaries';

export const useGetAllAccountsWithBeneficiaries =
    requestBuilder.query<AllAccountsWithBeneficiariesDetails>({
        endpoint: () => '/api/beneficiary/accounts',
        queryKey: () => 'getAllAccountsWithBeneficiaries',
    });
